export function milestoneHeadline(milestone: string) {
  const sentence = milestone.split(/\.\s/)[0].split(' — ')[0].replace(/\.$/, '')
  const goal = sentence.replace(/^By the end of the course,\s*/i, '')
  return goal.charAt(0).toUpperCase() + goal.slice(1)
}
